module.exports = __webpack_public_path__ + "media/images/green_tick_check_box-114167ebfa8ff7ca717bd03ba9248135.svg";